<script>
  import { link } from "svelte-routing";
</script>

<a class="view-all-card" href="/reports/sectors" use:link>
  <h2>View All<br />Sectors</h2>
  <span class="button">Go</span>
</a>

<style>
  .view-all-card {
    padding: 20px;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);
    border-radius: 0px 0px 10px 10px;
    color: #4a4a4a;
    cursor: pointer;
    text-align: center;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .button {
    margin-top: 20px;
  }

  .view-all-card:hover .button,
  .view-all-card:focus .button {
    background: #006b97;
  }
</style>
